import * as actionTypes from './ActionTypes';
import { setDefaultReducer } from '../helpers/Reducer';


export const setAppLang = setDefaultReducer(actionTypes.SET_APP_LANG);